module.exports = "form > mat-input-container {\n  display: block;\n  width: 100%; }\n\nform > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\nform > div > mat-input-container {\n    width: 250px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/countries/country-form/country-form.component.scss
// module id = ./libs/atenea-cms-brand/src/countries/country-form/country-form.component.scss
// module chunks = main